// looks like not used anywhere

import { Component, OnInit } from '@angular/core';
import { ImageUtilsService } from '../services/image-utils.service';

@Component({
  selector: 'app-dimensions-toggle',
  templateUrl: './dimensions-toggle.component.html',
  styleUrls: ['./dimensions-toggle.component.scss']
})
export class DimensionsToggleComponent implements OnInit {
  public isShowDimensions: boolean;
  constructor(public imageUtilsService: ImageUtilsService) {
    this.imageUtilsService.isShowDimensionsObservable.subscribe(v => this.isShowDimensions = v);
  }

  setDimensions() {
    this.imageUtilsService.isShowDimensionsSubject.next(!this.isShowDimensions);
    this.changeToggleIcon();
    if (this.isShowDimensions) {
      this.imageUtilsService.showSprites();
    }
    else {
      this.imageUtilsService.hideSprites();
    }
  }

  changeToggleIcon() {
    let img: any = document.getElementsByClassName('img-dim-toggle')[0];

    if (this.isShowDimensions) {
      img.src = '../../assets/images/Show_dim.png';
    }
    else {
      img.src = '../../assets/images/hide_dim.png';
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dimensions-toggle/dimensions-toggle.component.ts